import { TypeInstallationComponent } from "./type-installation.component";

export const TypeInstallation = TypeInstallationComponent;